import { render, staticRenderFns } from "./eventPollingDesc.vue?vue&type=template&id=2266b9a1&scoped=true"
import script from "./eventPollingDesc.vue?vue&type=script&lang=js"
export * from "./eventPollingDesc.vue?vue&type=script&lang=js"
import style0 from "./eventPollingDesc.vue?vue&type=style&index=0&id=2266b9a1&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2266b9a1",
  null
  
)

export default component.exports